import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const tok = typeof window !== "undefined" && window.localStorage.getItem("gmh_token");
  if (tok) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});

export const fetchBrands = () => api.get("/brands").then((r) => r.data);
export const fetchProperties = (params = {}) => api.get("/properties", { params }).then((r) => r.data);
export const fetchProperty = (id) => api.get(`/properties/${id}`).then((r) => r.data);
export const fetchResidences = (params = {}) => api.get("/residences", { params }).then((r) => r.data);
export const fetchResidence = (id) => api.get(`/residences/${id}`).then((r) => r.data);
export const unifiedSearch = (params = {}) => api.get("/search", { params }).then((r) => r.data);

export const signIn = (email, name) => api.post("/auth/session", { email, name }).then((r) => r.data);
export const me = () => api.get("/auth/me").then((r) => r.data);
export const signOut = () => api.post("/auth/logout").then((r) => r.data);

export const listBookings = () => api.get("/bookings").then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const cancelBooking = (id) => api.post(`/bookings/${id}/cancel`).then((r) => r.data);
export const listEnquiries = () => api.get("/enquiries").then((r) => r.data);
export const createEnquiry = (payload) => api.post("/enquiries", payload).then((r) => r.data);
export const withdrawEnquiry = (id) => api.post(`/enquiries/${id}/withdraw`).then((r) => r.data);

export const listFavourites = () => api.get("/me/favourites").then((r) => r.data);
export const addFavourite = (id) => api.post(`/me/favourites/${id}`).then((r) => r.data);
export const removeFavourite = (id) => api.delete(`/me/favourites/${id}`).then((r) => r.data);

export const adminDashboard = () => api.get("/admin/dashboard").then((r) => r.data);
export const adminBookings = (params = {}) => api.get("/admin/bookings", { params }).then((r) => r.data);
export const adminEnquiries = (params = {}) => api.get("/admin/enquiries", { params }).then((r) => r.data);
export const adminUpdateEnquiryStatus = (id, status) =>
  api.post(`/admin/enquiries/${id}/status`, { status }).then((r) => r.data);
export const adminMarkContacted = (id) => api.post(`/admin/enquiries/${id}/contact`).then((r) => r.data);
export const adminResetDemo = () => api.post("/admin/reset-demo").then((r) => r.data);
